// extracted by mini-css-extract-plugin
module.exports = {"social_media":"style_social_media__3Bjwv","social_media__link":"style_social_media__link__2WqmX","social_media__icon":"style_social_media__icon__20w4g"};